(function () {
  var form = document.getElementById('ProductForm');
  if (!form) return;

  var variantIdInput = form.querySelector('[data-variant-id]');
  var swatches = form.querySelectorAll('[data-option-value]');
  var submitBtn = form.querySelector('[data-add-to-cart]');
  var submitText = form.querySelector('[data-add-to-cart-text]');
  var thumbs = document.querySelectorAll('[data-gallery-thumb]');
  var slides = document.querySelectorAll('[data-gallery-slide]');

  function showGalleryIndex(index) {
    if (index === undefined || index === null) return;
    index = String(index);
    thumbs.forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-index') === index);
    });
    slides.forEach(function (s) {
      s.classList.toggle('is-active', s.getAttribute('data-index') === index);
    });
    var activeThumb = document.querySelector('[data-gallery-thumb][data-index="' + index + '"]');
    if (activeThumb && activeThumb.scrollIntoView) {
      activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }
  }

  // --- Quantity stepper ---
  var qtyInput = document.getElementById('Quantity');
  var decreaseBtn = document.querySelector('[data-qty-decrease]');
  var increaseBtn = document.querySelector('[data-qty-increase]');
  if (decreaseBtn && qtyInput) {
    decreaseBtn.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = Math.max(1, val - 1);
    });
  }
  if (increaseBtn && qtyInput) {
    increaseBtn.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = val + 1;
    });
  }

  // --- Gallery thumbnail clicks ---
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      showGalleryIndex(thumb.getAttribute('data-index'));
    });
  });

  // --- Variant selection ---
  var selected = {};
  swatches.forEach(function (btn) {
    var index = btn.getAttribute('data-option-index');
    if (!(index in selected)) {
      var group = form.querySelectorAll('[data-option-index="' + index + '"]');
      var active = Array.prototype.find.call(group, function (b) { return b.classList.contains('is-selected'); });
      selected[index] = active ? active.getAttribute('data-option-value') : group[0].getAttribute('data-option-value');
    }

    btn.addEventListener('click', function () {
      var group = form.querySelectorAll('[data-option-index="' + index + '"]');
      group.forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      selected[index] = btn.getAttribute('data-option-value');
      updateVariant();
    });
  });

  function updateVariant() {
    if (!window.__productVariants) return;

    var match = window.__productVariants.find(function (variant) {
      return Object.keys(selected).every(function (idx) {
  var optionValues = Array.isArray(variant.options)
  ? variant.options
  : [variant.option1, variant.option2, variant.option3];

return optionValues[Number(idx)] === selected[idx];
      });
    });

    if (!match) return;

    variantIdInput.value = match.id;
    var available = match.available;
    submitBtn.disabled = !available;
    submitText.textContent = available ? 'Dodaj do koszyka' : 'Niedostępny';

    var mediaId = window.__variantMediaMap && window.__variantMediaMap[String(match.id)];
    var galleryIndex = mediaId && window.__productMediaIndex
      ? window.__productMediaIndex[String(mediaId)]
      : null;

    if (galleryIndex !== undefined && galleryIndex !== null) {
      showGalleryIndex(galleryIndex);
    }
  }

  // Align image and hidden variant with the initially selected variant.
  updateVariant();

  // --- Add to cart via AJAX so the header cart-count updates without reload ---
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    submitBtn.disabled = true;
    var originalText = submitText.textContent;
    submitText.textContent = 'Dodawanie…';

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: variantIdInput.value,
        quantity: qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1
      })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var countEl = document.querySelector('.cart-count');
        if (countEl) countEl.textContent = cart.item_count;
        submitText.textContent = 'Dodano ✓';
        setTimeout(function () {
          submitText.textContent = originalText;
          submitBtn.disabled = false;
        }, 1800);
      })
      .catch(function () {
        submitText.textContent = originalText;
        submitBtn.disabled = false;
        window.location.href = '/cart';
      });
  });
})();
